export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEOS1NDbXMtVUhDLUhXLUhhEKGiAb54AQC+egAAwQACAr57AQC+fgQLvn8tAL8LgzUAvwwGAb8NAgC/DwEAvxALBb8RGwC/FwEAvxgBAL8ZGwO/Gg==", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/KSCms-UHC-HW-V.bcmap
// module id = 676
// module chunks = 502